import { Component } from 'angular-ts-decorators';

@Component({
  selector: 'app-loader',
  template: require('./loader.component.html'),
  styles: [ require('./loader.component.scss') ]
})
export class LoaderComponent {
}
